import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import BaseModal from '../../../../../_shared/components/BaseModal';
import Detail from '../../../../../_shared/components/Detail';
import useEscModalTracking from '../../../../../_shared/hooks/useEscModalTracking';
import isOmpPlatform from '../../../../../_shared/utils/isOmpPlatform';
import {
  Container,
  CloseButton,
  VehicleSeatIcon,
  Content,
  VehicleInfoDetail,
  VinButton,
  VehicleFeaturesContainer,
  VehicleFeaturesHeader,
  VinCopyIcon,
  CloseIcon
} from './Styles';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  tradeDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  copyVin: PropTypes.func.isRequired
};

const VehicleInfoModal = ({ isOpen, closeModal, tradeDetails, copyVin }) => {
  const isOmp = isOmpPlatform();

  useEscModalTracking('VDP-Full specs & features', isOpen);
  return (
    <BaseModal
      isOpen={isOpen}
      width={438}
      padding="0px 24px 24px"
      onRequestClose={closeModal}
      isClickEscClose
      hasParentSelector={isOmp}
      testId="vdp-vehicle-info-modal"
    >
      <Container>
        <CloseButton onClick={closeModal}>
          {/* CLOSE */}
          <FormattedMessage id="vdp.close" />
          <CloseIcon />
        </CloseButton>
        <Content>
          <VehicleSeatIcon />
          {/* Full specs & features */}
          <FormattedMessage id="vdp.overview.specsFeatures" />
        </Content>
        <Content>
          <VehicleInfoDetail spacing={60}>
            <Detail.Label>
              {/* Year */}
              <FormattedMessage id="tr5.year" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.year}</Detail.Value>
          </VehicleInfoDetail>
          <VehicleInfoDetail>
            <Detail.Label>
              {/* Make */}
              <FormattedMessage id="vdp.overview.make" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.manufacturerName}</Detail.Value>
          </VehicleInfoDetail>
        </Content>
        <Content>
          <VehicleInfoDetail spacing={45}>
            <Detail.Label>
              {/* Model */}
              <FormattedMessage id="vdp.overview.model" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.modelName}</Detail.Value>
          </VehicleInfoDetail>
          <VehicleInfoDetail>
            <Detail.Label>
              {/* Trim */}
              <FormattedMessage id="vdp.overview.trim" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.trim}</Detail.Value>
          </VehicleInfoDetail>
        </Content>
        <Content>
          <VehicleInfoDetail spacing={45}>
            <Detail.Label>
              {/* Transmission & drivetrain */}
              <FormattedMessage id="vdp.overview.transmissionDriveTrain" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.transmissionDriveTrain}</Detail.Value>
          </VehicleInfoDetail>
          <VehicleInfoDetail>
            <Detail.Label>
              {/* Odometer */}
              <FormattedMessage id="tr5.odometer" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.odometerDisplay}</Detail.Value>
          </VehicleInfoDetail>
        </Content>
        <Content>
          <VehicleInfoDetail spacing={80}>
            <Detail.Label>
              {/* Exterior/Interior colour */}
              <FormattedMessage id="vdp.overview.color" />
            </Detail.Label>
            <Detail.Value>
              {tradeDetails.exteriorColor}/{tradeDetails.interiorColor}
            </Detail.Value>
          </VehicleInfoDetail>
          <VehicleInfoDetail>
            <Detail.Label>
              {/* Seats */}
              <FormattedMessage id="vdp.overview.seats" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.passengers}</Detail.Value>
          </VehicleInfoDetail>
        </Content>
        <Content>
          <VehicleInfoDetail spacing={45}>
            <Detail.Label>
              {/* VIN */}
              <FormattedMessage id="vdp.overview.vin" />
            </Detail.Label>
            <Detail.Value>
              <VinButton onClick={() => copyVin('VDP-Full specs & features')}>
                {tradeDetails.vin}
                <VinCopyIcon />
              </VinButton>
            </Detail.Value>
          </VehicleInfoDetail>
          <VehicleInfoDetail>
            <Detail.Label>
              {/* Trade ID */}
              <FormattedMessage id="vdp.overview.tradeId" />
            </Detail.Label>
            <Detail.Value>{tradeDetails.id}</Detail.Value>
          </VehicleInfoDetail>
        </Content>
        <VehicleFeaturesContainer>
          <VehicleFeaturesHeader>
            {/* Vehicle features */}
            <FormattedMessage id="vdp.overview.vehicleFeatures" />
          </VehicleFeaturesHeader>
          {tradeDetails.options &&
            tradeDetails.options.map(option => {
              return (
                <React.Fragment key={option}>
                  {option}
                  <br />
                </React.Fragment>
              );
            })}
        </VehicleFeaturesContainer>
      </Container>
    </BaseModal>
  );
};

VehicleInfoModal.propTypes = propTypes;

export default VehicleInfoModal;
